import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import TablePaginate from 'components/Paginate';

import * as AppPics from 'assets/images';
import MetricCard from 'components/Inputs/MetricCard';
import AnalyticsCard from 'components/Inputs/AnalyticsCard';
import AnalyticsFilterDropdown from 'components/molecules/AnalyticsFilterDropdown';
// import useAnalyticsSummary from 'hooks/API/GET/useAnalyticsSummary';
// import useAnalyticsEpisodes from 'hooks/API/GET/useAnalyticsEpisodes';

function Analytics() {
  const history = useHistory();
  const [params, setParams] = usePaginateDefaults({ limit: 5, page: 0 });
  const [total, setTotal] = useState(0);

  const [filters, setFilters] = useState({ timeRange: 'last30', playable: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(false);

  // const {
  //   data: summaryResponse,
  //   isLoading: loadingSummary,
  //   isError: summaryError,
  // } = useAnalyticsSummary({
  //   enabled: !!filters.timeRange,
  //   config: { params: { timeRange: filters.timeRange, playable: filters.playable } },
  //   queryKey: ['analytics-summary', filters],
  //   mock: true, // <-- use mock data until real API is ready
  // });

  // const summary = summaryResponse?.data;

  // Time range options
  const timeRangeOptions = [
    { value: 'last7', label: 'Last 7 Days' },
    { value: 'last30', label: 'Last 30 Days' },
    { value: 'last90', label: 'Last 3 Months' },
    { value: 'last365', label: '1 Year' },
    { value: 'all', label: 'All Time' },
  ];

  // Podcast options
  const podcastOptions = [
    { value: 'playable1', label: 'The Future of AI' },
    { value: 'playable2', label: 'Business Insights' },
    { value: 'playable3', label: 'Tech Talks' },
  ];

  useEffect(() => {
    setLoading(true);

    // All mock episodes (master list)
    const allEpisodes = [
      {
        id: 1,
        title: 'The Future of AI in Podcast Production',
        date: '2024-01-20',
        plays: '15,420',
        unique: '12,350',
        repeat: '3,070',
        avgTime: '32:45',
        status: 'Trending',
        podcastId: 'playable1',
      },
      {
        id: 2,
        title: 'Building a Sustainable Podcast Business',
        date: '2024-01-18',
        plays: '12,890',
        unique: '10,200',
        repeat: '2,690',
        avgTime: '28:12',
        status: 'Stable',
        podcastId: 'playable2',
      },
      {
        id: 3,
        title: 'Tech Trends for 2024',
        date: '2024-01-15',
        plays: '10,000',
        unique: '8,000',
        repeat: '2,000',
        avgTime: '30:10',
        status: 'Declining',
        podcastId: 'playable3',
      },
    ];

    setTimeout(() => {
      // Apply dropdown filter
      let filtered = allEpisodes;

      if (filters.playable) {
        filtered = filtered.filter((ep) => ep.podcastId === filters.playable);
      }

      // Apply search filter
      if (searchTerm.trim() !== '') {
        filtered = filtered.filter((ep) =>
          ep.title.toLowerCase().includes(searchTerm.trim().toLowerCase())
        );
      }
      const start = params.page * params.limit;
      const end = start + params.limit;
      const paginated = filtered.slice(start, end);

      setEpisodes(paginated);
      setLoading(false);
    }, 500);
  }, [filters, searchTerm, params]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const performSearch = (value) => {
    setSearchTerm(value);
    setParams((prev) => ({ ...prev, page: 0 }));
  };

  const handleBackNavigation = () => {
    history.push('/podcast');
  };

  const handleTimeRangeChange = (event) => {
    setFilters({ ...filters, timeRange: event.target.value });
  };

  const handlePodcastChange = (event) => {
    setFilters({ ...filters, playable: event.target.value });
  };

  function getStatusClass(status) {
    switch (status) {
      case 'Trending':
        return 'success';
      case 'Stable':
        return 'primary';
      case 'Declining':
        return 'danger';
      default:
        return 'secondary';
    }
  }

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleBackNavigation}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          {/* Breadcrumbs */}
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Podcast Home', to: '/podcast' },
              ]}
              current="Analytics"
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              <div className="tab__contentMenu">
                <ul className="tab__contentMenu-list">
                  <li>
                    <h2 className="prime-head p-0 boldtitle text-nowrap">Podcast Analytics</h2>
                  </li>
                </ul>
              </div>

              <div className="analytics-content-section">
                {/* Top Shortcut Cards */}
                <div className="row mb-4">
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <AnalyticsCard
                      iconKey="totalPlays"
                      title="Total Plays"
                      subtitle="View all podcast plays and statistics"
                      onClick={() => console.log('Navigate to Total Plays')}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <AnalyticsCard
                      iconKey="audience"
                      title="Audience"
                      subtitle="Access listener demographics and insights"
                      onClick={() => console.log('Navigate to Audience')}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <AnalyticsCard
                      iconKey="analytics"
                      title="Analytics"
                      subtitle="Detailed performance metrics and reports"
                      onClick={() => console.log('Navigate to Analytics')}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <AnalyticsCard
                      iconKey="addEpisode"
                      title="Add Episode"
                      subtitle="Upload and manage new podcast episodes"
                      onClick={() => console.log('Navigate to Add Episode')}
                    />
                  </div>
                </div>

                {/* Filter Container */}
                <div className="analytics-filter-container card mb-4">
                  <div className="row align-items-center">
                    {/* Filter Icon */}
                    <div className="col-12 col-sm-auto mb-3 mb-sm-0">
                      <div className="analytics-filter-header d-flex align-items-center">
                        <img src={AppPics.TabFilterSvg} alt="Filter" />
                        <span className="analytics-filter-label">Filters</span>
                      </div>
                    </div>

                    {/* Time Range Dropdown */}
                    <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                      <AnalyticsFilterDropdown
                        label="Time Range"
                        value={filters.timeRange}
                        options={timeRangeOptions}
                        handleChange={handleTimeRangeChange}
                        placeholder="Select time range"
                        version="default"
                        tabIndex={1}
                      />
                    </div>

                    {/* Podcast Dropdown */}
                    <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                      <AnalyticsFilterDropdown
                        label="Podcast"
                        value={filters.playable}
                        options={podcastOptions}
                        handleChange={handlePodcastChange}
                        placeholder="All Podcasts"
                        version="default"
                        tabIndex={2}
                      />
                    </div>

                    {/* Search Box */}
                    <div className="col-12 col-md-4">
                      <label>Search Episode</label>
                      <div className="position-relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search episodes..."
                          type="text"
                          value={searchTerm}
                          onChange={handleSearchChange}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              performSearch(searchTerm);
                            }
                          }}
                          tabIndex={3}
                        />
                        <span
                          className="mainHeader__searchBtn"
                          onClick={() => performSearch(searchTerm)}
                        >
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Metric Cards */}
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <MetricCard
                      title="Total Plays"
                      value="1.2M"
                      change={12.5}
                      changeType="increase"
                      icon="play"
                      description="Last 30 days"
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <MetricCard
                      title="Unique Listeners"
                      value="245K"
                      change={8.2}
                      changeType="increase"
                      icon="user"
                      description="Active users"
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <MetricCard
                      title="Repeat Listeners"
                      value="89K"
                      change={-2.1}
                      changeType="decrease"
                      icon="repeat"
                      description="Returning audience"
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <MetricCard
                      title="Avg Listen Time"
                      value="32:45"
                      change={5.8}
                      changeType="increase"
                      icon="clock"
                      description="Per episode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Episode Table */}
          <div className="px-5 py-5">
            <h2 className="mb-3">Episode Performance</h2>

            <div className="tab__contentBody">
              <div className="tableWrap">
                <div className="table-responsive">
                  <table className="table tableWrap__table">
                    <thead className="thead-light __appTheadColor">
                      <tr>
                        <th className="text-center">Episode</th>
                        <th className="text-center">Total Plays</th>
                        <th className="text-center">Unique Listeners</th>
                        <th className="text-center">Repeat Listeners</th>
                        <th className="text-center">Avg Listen Time</th>
                        <th className="text-center">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={6} className="text-center py-4">
                            Loading episodes...
                          </td>
                        </tr>
                      ) : episodes.length > 0 ? (
                        episodes.map((ep, idx) => (
                          <tr key={ep.id}>
                            <td className="text-center">{ep.title}</td>
                            <td className="text-center">{ep.plays}</td>
                            <td className="text-center">{ep.unique}</td>
                            <td className="text-center">{ep.repeat}</td>
                            <td className="text-center">{ep.avgTime}</td>
                            <td className="text-center">
                              <span className={`badge badge-${getStatusClass(ep.status)}`}>
                                {ep.status}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center py-4">
                            No episodes found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePaginate
                currentPage={params.page + 1}
                maxCount={total}
                defaultLimit={params.limit}
                setPage={(page) => setParams((prev) => ({ ...prev, page: page - 1 }))}
                handleChange={(limit) => setParams((prev) => ({ ...prev, limit, page: 0 }))}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
